import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { IPrivateEndpointCompatible } from 'shell-models-lib';

export const azureMLServiceAuthTypes = {
    ServicePrincipalAuthentication: 'ServicePrincipalAuthentication',
    MSIAuthentication: 'MSIAuthentication'
};

@Metamodel.model({
    name: 'AzureMLService',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureMLService_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureMLService_DisplayText)
    ]
})
export class AzureMLServiceLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.Authentication
    })
    public authenticationMethod?: string = azureMLServiceAuthTypes.MSIAuthentication;

    @Metamodel.attribute({
        display: stringResources.SubscriptionId
    })
    public subscriptionId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ResourceGroupName
    })
    public resourceGroupName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MLWorkspaceName
    })
    public mlWorkspaceName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant?: string;

    private _workspaceResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        const resourceName = this.mlWorkspaceName;
        if (!resourceName || this._workspaceResourceID && !this._workspaceResourceID.endsWith('/' + resourceName)) {
            this._workspaceResourceID = undefined;
        }
        return {
            id: this._workspaceResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._workspaceResourceID = id;
    }
}
